import { render, staticRenderFns } from "./StatisticChart.vue?vue&type=template&id=bcaa74b4"
import script from "./StatisticChart.vue?vue&type=script&lang=js"
export * from "./StatisticChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports